/** Join multiple class names into a single string, ignoring falsy values. */
export function joinClassNames(...classNames: (string | false | null | undefined)[]): string {
    return classNames.filter(Boolean).join(' ');
}

/**
 * Clamp a heading level to be between 1 and 6, defaulting to 2 if the input is not a finite number.
 */
export function clampHeadingLevel(level: number): number {
    if (!Number.isFinite(level)) {
        return 2;
    }
    return Math.min(Math.max(Math.round(level), 1), 6);
}

/**
 * Build a URL-friendly slug from a title string. If the title is null or results in an empty slug,
 * the provided fallback string is returned instead.
 *
 * This slug can be used in HTML id attributes (e.g. for anchors) or in URLs.
 */
export function buildSlug(title: string | null, fallback: string): string {
    if (!title) {
        return fallback;
    }
    const slug = title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    return slug || fallback;
}
